<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "industry",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "交易规模",
                        data: "shares",
                        unit: "亿元"
                    }
                ],
                name: '电商SaaS'
            }
        }
    },
    created() {
        this.$store.dispatch('getIndustry', this.params)
    }
}
</script>